import React from 'react'
import { useStyles } from './report-template-header.style'
import logo from '#base/assets/img/novisci-dark-background.png'
import { REPORT_TYPES_LABEL } from '../constants'

export const ReportTemplateHeader = function ({ report }) {
  const classes = useStyles()

  return (
    <div className={classes.headerWrapper}>
      <header className={classes.header}>
        <div className={classes.headerLeft}>
          <div className={classes.reportType}>{REPORT_TYPES_LABEL[report.type]}:</div>
          <h1 className={classes.reportTitle}>
            {report.title}
          </h1>
        </div>
        <div className={classes.headerRight}>
          <div className={classes.logoContainer}>
            <img src={logo} className={classes.logo} />
          </div>
        </div>
      </header>
    </div>
  )
}
